import { useEffect, useState } from 'react'

/** La valeur, `delay` ms après la dernière frappe : une recherche serveur par pause, pas par touche. */
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])
  return debounced
}
